/**
 * @fileoverview Tarjeta grande con el texto de la statement actual.
 * Animación de entrada/salida horizontal con Framer Motion.
 */

import { AnimatePresence, motion } from "framer-motion";

/**
 * @param {{ id: string, codigo: string, texto: string }} props
 */
export function StatementCard({ id, codigo, texto }) {
    return (
        <AnimatePresence mode="wait">
            <motion.article
                key={id}
                initial={{ opacity: 0, x: 24 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -24 }}
                transition={{ duration: 0.2 }}
                aria-live="polite"
                aria-atomic="true"
                className="bg-card border border-border rounded-2xl p-8 sm:p-10 shadow-sm"
                data-testid="statement-card"
            >
                <p className="text-xs uppercase tracking-wider text-muted-foreground font-medium mb-4">
                    {codigo}
                </p>
                <p
                    className="text-xl sm:text-2xl lg:text-[1.75rem] leading-relaxed sm:leading-loose text-foreground"
                    data-testid="statement-text"
                >
                    {texto}
                </p>
            </motion.article>
        </AnimatePresence>
    );
}
